import {platformIcons} from '../../assets/images/platformIcons';


interface InstructionData {
    platform: string;
    protocol: string;
    icon: string;
    installDescription: string;
    installLink?: string;
    installLinks?: { ru?: string; global?: string };
    subscriptionDescription: string;
    useDescription: string;
}

interface ImageInstructionData {
    platform: string;
    protocol: string;
    icon: string;
    images: {
        step: number;
        title: string;
        description: string;
        imageUrl: string;
        imageAlt: string;
    }[];
}

export const instructionsData: Record<string, Record<string, InstructionData>> = {
    ios: {
        vless: {
            platform: 'iOS',
            protocol: 'VLESS',
            icon: platformIcons.ios,
            installDescription: 'Откройте страницу в App Store и установите приложение. Запустите его, в окне разрешения VPN-конфигурации нажмите Allow и введите свой пароль.',
            installLinks: {
                ru: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973',
                global: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215'
            },
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
        wireguard: {
            platform: 'iOS',
            protocol: 'WireGuard',
            icon: platformIcons.ios,
            installDescription: 'Откройте страницу в App Store и установите приложение. Запустите его, в окне разрешения VPN-конфигурации нажмите Allow и введите свой пароль.',
            installLink: 'https://apps.apple.com/ru/app/wireguard/id1441195209',
            subscriptionDescription: 'Сначала скачайте файл конфигурации во вкладке устройства. После этого запустите приложение WireGuard, нажмите "+", выберите "Создать из файла или архива" и загрузите скачанный файл.',
            useDescription: 'Все готово — можно подключаться. Нажмите на ползунок справа от профиля с тем же названием, что и у скачанного файла, чтобы включить VPN.',
        },
        amneziawg: {
            platform: 'iOS',
            protocol: 'AmneziaWG',
            icon: platformIcons.ios,
            installDescription: 'Откройте страницу в App Store и установите приложение. Запустите его, в окне разрешения VPN-конфигурации нажмите Allow и введите свой пароль.',
            installLink: 'https://apps.apple.com/ru/app/amneziawg/id6478942365',
            subscriptionDescription: 'Сначала скачайте файл конфигурации во вкладке устройства. После этого запустите приложение AmneziaWG, нажмите "+", выберите "Создать из файла или архива" и загрузите скачанный файл.',
            useDescription: 'Все готово — можно подключаться. Нажмите на ползунок справа от профиля с тем же названием, что и у скачанного файла, чтобы включить VPN.',
        },
        vless_incy: {
            platform: 'iOS',
            protocol: 'VLESS_INCY',
            icon: platformIcons.ios,
            installDescription: 'Откройте страницу в App Store и установите приложение.',
            installLinks: {
                ru: 'https://apps.apple.com/ru/app/incy/id6756943388',
                global: 'https://apps.apple.com/ru/app/incy/id6756943388'
            },
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
    },
    android: {
        vless: {
            platform: 'Android',
            protocol: 'VLESS',
            icon: platformIcons.android,
            installDescription: 'Откройте страницу в Google Play и установите приложение.',
            installLink: 'https://play.google.com/store/apps/details?id=com.happproxy',
            subscriptionDescription: 'После установки приложения перейдите в приложение. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
        wireguard: {
            platform: 'Android',
            protocol: 'WireGuard',
            icon: platformIcons.android,
            installDescription: 'Откройте страницу в Google Play и установите приложение.',
            installLink: 'https://play.google.com/store/apps/details?id=com.wireguard.android',
            subscriptionDescription: 'Сначала скачайте файл конфигурации, нажав на кнопку ниже. После этого запустите приложение WireGuard, нажмите "+", выберите "Создать из файла или архива" и загрузите скачанный файл.',
            useDescription: 'Все готово — можно подключаться. Нажмите на ползунок справа от профиля с тем же названием, что и у скачанного файла, чтобы включить VPN.',
        },
        amneziawg: {
            platform: 'Android',
            protocol: 'AmneziaWG',
            icon: platformIcons.android,
            installDescription: 'Откройте страницу в Google Play и установите приложение.',
            installLink: 'https://play.google.com/store/apps/details?id=org.amnezia.awg',
            subscriptionDescription: 'Сначала скачайте файл конфигурации, нажав на кнопку ниже. После этого запустите приложение AmneziaWG, нажмите "+", выберите "Создать из файла или архива" и загрузите скачанный файл.',
            useDescription: 'Все готово — можно подключаться. Нажмите на ползунок справа от профиля с тем же названием, что и у скачанного файла, чтобы включить VPN.',
        },
        vless_incy: {
            platform: 'Android',
            protocol: 'VLESS_INCY',
            icon: platformIcons.android,
            installDescription: 'Откройте страницу в Google Play и установите приложение.',
            installLink: 'https://play.google.com/store/apps/details?id=llc.itdev.incy',
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
    },
    windows: {
        vless: {
            platform: 'Windows',
            protocol: 'VLESS',
            icon: platformIcons.windows,
            installDescription: 'Нажмите на кнопку ниже и установите приложение.',
            installLink: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/setup-Happ.x64.exe',
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
        wireguard: {
            platform: 'Windows',
            protocol: 'WireGuard',
            icon: platformIcons.windows,
            installDescription: 'Нажмите на кнопку ниже и установите приложение.',
            installLink: 'https://download.wireguard.com/windows-client/wireguard-installer.exe',
            subscriptionDescription: 'Сначала скачайте файл конфигурации, нажав на кнопку ниже. После этого запустите приложение WireGuard, нажмите «Добавить туннель» в правом нижнем углу, выберите пункт «Импорт туннеля из файла» и укажите скачанный файл.',
            useDescription: 'Нажмите на появившийся профиль — его название будет таким же, как у файла, — затем нажмите «Подключить».',
        },
        amneziawg: {
            platform: 'Windows',
            protocol: 'AmneziaWG',
            icon: platformIcons.windows,
            installDescription: 'Нажмите на кнопку ниже и установите приложение.',
            installLink: 'https://appnet.shadownet.nl/downloads/ShadowNetVPN_x64.exe',
            subscriptionDescription: 'Сначала скачайте файл конфигурации, нажав на кнопку ниже. После этого запустите приложение AmneziaVPN, нажмите "+", выберите «Файл с настройками подключения» и загрузите скачанный файл. Нажмите "Подключиться".',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN.',
        },
        vless_incy: {
            platform: 'Windows',
            protocol: 'VLESS_INCY',
            icon: platformIcons.windows,
            installDescription: 'Нажмите на кнопку ниже и установите приложение.',
            installLink: 'https://github.com/INCY-DEV/incy-platforms/releases/download/desktop-v3.4.0/incy-windows-setup.exe',
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
    },
    macos: {
        vless: {
            platform: 'macOS',
            protocol: 'VLESS',
            icon: platformIcons.macos,
            installDescription: 'Откройте страницу в App Store и установите приложение. Запустите его, в окне разрешения VPN-конфигурации нажмите Allow и введите свой пароль.',
            installLinks: {
                ru: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973',
                global: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215'
            },
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
        wireguard: {
            platform: 'macOS',
            protocol: 'WireGuard',
            icon: platformIcons.macos,
            installDescription: 'Откройте страницу в App Store и установите приложение. Запустите его, в окне разрешения VPN-конфигурации нажмите Allow и введите свой пароль.',
            installLink: 'https://apps.apple.com/ru/app/wireguard/id1441195209',
            subscriptionDescription: 'Сначала скачайте файл конфигурации, нажав на кнопку ниже. После этого запустите приложение WireGuard, нажмите "+", выберите «Создать из файла или архива» и загрузите скачанный файл.',
            useDescription: 'Все готово — можно подключаться. Нажмите на ползунок справа от профиля с тем же названием, что и у скачанного файла, чтобы включить VPN.',
        },
        amneziawg: {
            platform: 'macOS',
            protocol: 'AmneziaWG',
            icon: platformIcons.macos,
            installDescription: 'Откройте страницу в App Store и установите приложение.',
            installLink: 'https://apps.apple.com/ru/app/amneziawg/id6478942365',
            subscriptionDescription: 'Сначала скачайте файл конфигурации, нажав на кнопку ниже. После этого запустите приложение AmneziaWG, нажмите "+", выберите «Создать из файла или архива» и загрузите скачанный файл.',
            useDescription: 'Все готово — можно подключаться. Нажмите на ползунок справа от профиля с тем же названием, что и у скачанного файла, чтобы включить VPN.',
        },
        vless_incy: {
            platform: 'macOS',
            protocol: 'VLESS_INCY',
            icon: platformIcons.macos,
            installDescription: 'Откройте страницу в App Store и установите приложение.',
            installLink: 'https://apps.apple.com/ru/app/incy/id6756943388',
            subscriptionDescription: 'После установки приложения, откройте его и нажмите на кнопку добавления подписки. Вставьте вашу ссылку подписки и нажмите "Добавить". Подписка будет автоматически активирована.',
            useDescription: 'В главном разделе нажмите большую кнопку включения в центре для подключения к VPN. Не забудьте выбрать сервер в списке серверов. При необходимости выберите другой сервер из списка серверов.',
        },
    },
};

// Инструкции с картинками (только для VLESS пока)
export const imageInstructionsData: Record<string, Record<string, ImageInstructionData>> = {
    ios: {
        vless: {
            platform: 'iOS',
            protocol: 'VLESS',
            icon: platformIcons.ios,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/ios/vless/step1.jpg'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Получение конфигурации',
                    description: 'Нажмите на кнопку копирования конфигурации.',
                    imageUrl: require('./images/ios/vless/step2.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Установка приложения',
                    description: 'Откройте App Store и установите приложение Happ. Запустите его.',
                    imageUrl: require('./images/ios/vless/step3.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Добавление подписки',
                    description: 'Нажмите на кнопку "+" в правом верхнем углу.',
                    imageUrl: require('./images/ios/vless/step4.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Выберите "Вставить из буфера обмена" и вставьте скопированную ссылку подписки.',
                    imageUrl: require('./images/ios/vless/step5.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
                {
                    step: 6,
                    title: 'Подключение',
                    description: 'После добавления подписки, нажмите на большую круглую кнопку в центре для подключения к VPN.',
                    imageUrl: require('./images/ios/vless/step6.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
            ]
        },
        wireguard: {
            platform: 'iOS',
            protocol: 'wireguard',
            icon: platformIcons.ios,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/ios/wg/step1.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Получение конфигурации',
                    description: 'Нажмите на кнопку поделиться.',
                    imageUrl: require('./images/ios/wg/step2.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Выберите пункт «Сохранить в Файлы», затем в правом верхнем углу нажмите «Сохранить».',
                    imageUrl: require('./images/ios/wg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Установка приложения',
                    description: 'Нажмите на кнопку скачать приложение в начале инструкции, перейдите в App Store и установите приложение wireguard. Запустите его.',
                    imageUrl: require('./images/ios/wg/step4.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Откройте приложение WireGuard и нажмите на значок «+» в правом верхнем углу.',
                    imageUrl: require('./images/ios/wg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 6,
                    title: 'Подключение',
                    description: 'Выберите пункт «Создать из файла или архива». ',
                    imageUrl: require('./images/ios/wg/step6.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 7,
                    title: 'Подключение',
                    description: 'Когда появится системное окно, разрешите добавление конфигурации VPN.',
                    imageUrl: require('./images/ios/wg/step7.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 8,
                    title: 'Подключение',
                    description: 'Нажмите «Подключить».',
                    imageUrl: require('./images/ios/wg/step8.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        amneziawg: {
            platform: 'iOS',
            protocol: 'AmneziaWG',
            icon: platformIcons.ios,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/ios/awg/step1.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Получение конфигурации',
                    description: 'Нажмите на кнопку поделиться.',
                    imageUrl: require('./images/ios/awg/step2.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Выберите пункт «Сохранить в Файлы», затем в правом верхнем углу нажмите «Сохранить».',
                    imageUrl: require('./images/ios/awg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Установка приложения',
                    description: 'Нажмите на кнопку скачать приложение в начале инструкции, перейдите в App Store и установите приложение AmneziaWG. Запустите его.',
                    imageUrl: require('./images/ios/awg/step4.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Откройте приложение AmneziaWG   и нажмите на значок «+» в правом верхнем углу.',
                    imageUrl: require('./images/ios/awg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 6,
                    title: 'Подключение',
                    description: 'Выберите пункт «Создать из файла или архива». Выбираем скаченный нами файл ранее.',
                    imageUrl: require('./images/ios/awg/step6.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 7,
                    title: 'Подключение',
                    description: 'Когда появится системное окно, разрешите добавление конфигурации VPN.',
                    imageUrl: require('./images/ios/awg/step7.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 8,
                    title: 'Подключение',
                    description: 'Нажмите «Подключить».',
                    imageUrl: require('./images/ios/awg/step8.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        vless_incy: {
            platform: 'iOS',
            protocol: 'VLESS_INCY',
            icon: platformIcons.ios,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на кнопку настроить устройства',
                    imageUrl: require('./images/ios/vless_incy/step1.jpg'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Протокол',
                    description: 'Выберете протокол Vless',
                    imageUrl: require('./images/ios/vless_incy/step2.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Подключение',
                    description: 'Нажмите на кнопку быстрое подключение incy',
                    imageUrl: require('./images/ios/vless_incy/step3.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Переход в incy',
                    description: 'Нажмите открыть в появившимся окне, если вы его закрыли можете нажать на кнопку открыть в incy',
                    imageUrl: require('./images/ios/vless_incy/step4.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Успешно, ваша подписка подключена!',
                    imageUrl: require('./images/ios/vless_incy/step5.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
            ]
        },
    },
    android: {
        vless: {
            platform: 'Android',
            protocol: 'VLESS',
            icon: platformIcons.android,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств',
                    imageUrl: require('./images/ios/vless/step1.jpg'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Получение конфигурации',
                    description: 'Нажмите на кнопку копирования конфигурации.',
                    imageUrl: require('./images/ios/vless/step2.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Установка приложения',
                    description: 'Откройте Google Play и установите приложение Happ.',
                    imageUrl: require('./images/android/vless/step3.jpg'),
                    imageAlt: 'Установка Happ на Android'
                },
                {
                    step: 4,
                    title: 'Добавление подписки',
                    description: 'Запустите приложение, нажмите на кнопку "+" и выберите "Вставить из буфера обмена". Вставьте скопированную ссылку.',
                    imageUrl: require('./images/android/vless/step4.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 5,
                    title: 'Подключение',
                    description: 'Нажмите на круглую кнопку включения в центре экрана.',
                    imageUrl: require('./images/android/vless/step5.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
                {
                    step: 6,
                    title: 'Выбор сервера',
                    description: 'Выберите сервер из списка для оптимальной скорости.',
                    imageUrl: require('./images/android/vless/step6.jpg'),
                    imageAlt: 'Выбор сервера в Happ'
                }
            ]
        },
        wireguard: {
            platform: 'Android',
            protocol: 'wireguard',
            icon: platformIcons.android,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Нажмите на кнопку скачать приложение в начале инструкции, перейдите в Google play и установите приложение wireguard. Запустите его.',
                    imageUrl: require('./images/android/wg/step1.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 2,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/android/wg/step2.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Нажмите на кнопку поделиться и сохраните файл.',
                    imageUrl: require('./images/android/wg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Получение конфигурации',
                    description: 'Откройте приложение WireGuard, нажимаем на кнопку "Импорт из файла или архива".',
                    imageUrl: require('./images/android/wg/step4.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Найдите файл, который скачали, выберите его и нажмите на кнопку "Готово".',
                    imageUrl: require('./images/android/wg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 6,
                    title: 'Подключение',
                    description: 'В приложении WireGuard выйдет такое окно, нажмите на "ОК"',
                    imageUrl: require('./images/android/wg/step6.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 7,
                    title: 'Подключение',
                    description: 'Нажмите на кнопку для подключения',
                    imageUrl: require('./images/android/wg/step7.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        amneziawg: {
            platform: 'Android',
            protocol: 'AmneziaWG',
            icon: platformIcons.android,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Нажмите на кнопку скачать приложение в начале инструкции, перейдите в PlayStore и установите приложение AmneziaWG. Запустите его.',
                    imageUrl: require('./images/android/awg/step1.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/android/awg/step2.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 3,
                    title: 'Получение конфигурации',
                    description: 'Нажмите на кнопку поделиться.',
                    imageUrl: require('./images/android/awg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Сохранение конфигурации',
                    description: 'Откройте приложение AmneziaWG и нажмите на значок «+» в правом верхнем углу.',
                    imageUrl: require('./images/android/awg/step4.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Выберите пункт «Создать из файла или архива». Выбираем скаченный нами файл ранее.',
                    imageUrl: require('./images/android/awg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 6,
                    title: 'Подключение',
                    description: 'Найдите и выберите скаченный файл.',
                    imageUrl: require('./images/android/awg/step6.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
                {
                    step: 7,
                    title: 'Подключение',
                    description: 'Включите VPN.',
                    imageUrl: require('./images/android/awg/step7.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        vless_incy: {
            platform: 'Android',
            protocol: 'VLESS_INCY',
            icon: platformIcons.android,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на кнопку настроить устройства',
                    imageUrl: require('./images/ios/vless_incy/step1.jpg'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Протокол',
                    description: 'Выберете протокол Vless',
                    imageUrl: require('./images/ios/vless_incy/step2.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Подключение',
                    description: 'Нажмите на кнопку быстрое подключение incy',
                    imageUrl: require('./images/ios/vless_incy/step3.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Переход в incy',
                    description: 'Нажмите открыть в появившимся окне, если вы его закрыли можете нажать на кнопку открыть в incy',
                    imageUrl: require('./images/ios/vless_incy/step4.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Успешно, ваша подписка подключена!',
                    imageUrl: require('./images/ios/vless_incy/step5.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
            ]
        },
    },
    windows: {
        vless: {
            platform: 'Windows',
            protocol: 'VLESS',
            icon: platformIcons.windows,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Скачайте и установите приложение Happ для Windows.',
                    imageUrl: require('./images/android/vless/step1.jpg'),
                    imageAlt: 'Установка Happ на Windows'
                },
                {
                    step: 2,
                    title: 'Добавление подписки',
                    description: 'Запустите приложение, нажмите "Get started" и вставьте скопированную ссылку подписки.',
                    imageUrl: require('./images/android/vless/step2.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 3,
                    title: 'Подключение',
                    description: 'Нажмите на круглую кнопку включения для активации VPN.',
                    imageUrl: require('./images/android/vless/step3.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
                {
                    step: 4,
                    title: 'Выбор сервера',
                    description: 'При необходимости выберите другой сервер из списка.',
                    imageUrl: require('./images/android/vless/step4.jpg'),
                    imageAlt: 'Выбор сервера в Happ'
                }
            ]
        },
        wireguard: {
            platform: 'Windows',
            protocol: 'wireguard',
            icon: platformIcons.windows,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Установим приложение нажав на кнопку скачать приложение в начале инструкции.',
                    imageUrl: require('./images/windows/wg/step1.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 2,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/windows/wg/step2.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Устанавливаем файл.',
                    imageUrl: require('./images/windows/wg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Добавление подписки',
                    description: 'Импортируем ранее скачанный файл конфигурации в приложение',
                    imageUrl: require('./images/windows/wg/step4.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 5,
                    title: 'Подключение',
                    description: 'Нажимаем на кнопку "Подключить". Убеждаемся, что трафик идёт.',
                    imageUrl: require('./images/windows/wg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        amneziawg: {
            platform: 'Windows',
            protocol: 'AmneziaWG',
            icon: platformIcons.windows,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Установим приложение нажав на кнопку скачать приложение в начале инструкции.',
                    imageUrl: require('./images/windows/awg/step1.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 2,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/windows/awg/step2.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Скачайте приложение и установите. После запуска нажмите на “Приступим”.',
                    imageUrl: require('./images/windows/awg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Добавление подписки',
                    description: 'Импортируем ранее скачанный файл конфигурации в приложение',
                    imageUrl: require('./images/windows/awg/step4.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 5,
                    title: 'Подключение',
                    description: 'Нажимаем на кнопку "Подключить".',
                    imageUrl: require('./images/windows/awg/step5.png'),
                    imageAlt: 'Подключение VPN в awg'
                },
            ]
        },
        vless_incy: {
            platform: 'Windows',
            protocol: 'VLESS_INCY',
            icon: platformIcons.windows,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на кнопку настроить устройства',
                    imageUrl: require('./images/ios/vless_incy/step1.jpg'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Протокол',
                    description: 'Выберете протокол Vless',
                    imageUrl: require('./images/ios/vless_incy/step2.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Подключение',
                    description: 'Нажмите на кнопку быстрое подключение incy',
                    imageUrl: require('./images/ios/vless_incy/step3.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Переход в incy',
                    description: 'Нажмите открыть в появившимся окне, если вы его закрыли можете нажать на кнопку открыть в incy',
                    imageUrl: require('./images/ios/vless_incy/step4.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Успешно, ваша подписка подключена!',
                    imageUrl: require('./images/ios/vless_incy/step5.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
            ]
        },
    },
    macos: {
        vless: {
            platform: 'macOS',
            protocol: 'VLESS',
            icon: platformIcons.macos,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Откройте App Store и установите приложение Happ.',
                    imageUrl: require('./images/android/vless/step1.jpg'),
                    imageAlt: 'Установка Happ на macOS'
                },
                {
                    step: 2,
                    title: 'Добавление подписки',
                    description: 'Запустите приложение, нажмите на кнопку "+" и выберите "Вставить из буфера обмена".',
                    imageUrl: require('./images/android/vless/step2.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 3,
                    title: 'Подключение',
                    description: 'Нажмите на круглую кнопку включения в центре экрана.',
                    imageUrl: require('./images/android/vless/step3.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
                {
                    step: 4,
                    title: 'Выбор сервера',
                    description: 'Выберите сервер для подключения из списка доступных.',
                    imageUrl: require('./images/android/vless/step4.jpg'),
                    imageAlt: 'Выбор сервера в Happ'
                }
            ]
        },
        wireguard: {
            platform: 'macOS',
            protocol: 'wireguard',
            icon: platformIcons.macos,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Установим приложение нажав на кнопку скачать приложение в начале инструкции.',
                    imageUrl: require('./images/macos/wg/step1.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 2,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/macos/wg/step2.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Устанавливаем файл.',
                    imageUrl: require('./images/macos/wg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Добавление подписки',
                    description: 'Импортируем ранее скачанный файл конфигурации в приложение',
                    imageUrl: require('./images/macos/wg/step4.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 5,
                    title: 'Подключение',
                    description: 'Нажимаем на кнопку "Подключить". Убеждаемся, что трафик идёт.',
                    imageUrl: require('./images/macos/wg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        amneziawg: {
            platform: 'macOS',
            protocol: 'AmneziaWG',
            icon: platformIcons.macos,
            images: [
                {
                    step: 1,
                    title: 'Установка приложения',
                    description: 'Установим приложение нажав на кнопку скачать приложение в начале инструкции.',
                    imageUrl: require('./images/macos/wg/step1.png'),
                    imageAlt: 'Добавление подписки в wireguard'
                },
                {
                    step: 2,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на шестеренку во вкладке устройств.',
                    imageUrl: require('./images/macos/wg/step2.png'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 3,
                    title: 'Сохранение конфигурации',
                    description: 'Устанавливаем файл.',
                    imageUrl: require('./images/macos/wg/step3.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Добавление подписки',
                    description: 'Импортируем ранее скачанный файл конфигурации в приложение',
                    imageUrl: require('./images/macos/wg/step4.png'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 5,
                    title: 'Подключение',
                    description: 'Нажимаем на кнопку "Подключить". Убеждаемся, что трафик идёт.',
                    imageUrl: require('./images/macos/wg/step5.png'),
                    imageAlt: 'Подключение VPN в WireGuard'
                },
            ]
        },
        vless_incy: {
            platform: 'macOS',
            protocol: 'VLESS_INCY',
            icon: platformIcons.macos,
            images: [
                {
                    step: 1,
                    title: 'Вкладка устройства',
                    description: 'Нажмите на кнопку настроить устройства',
                    imageUrl: require('./images/ios/vless_incy/step1.jpg'),
                    imageAlt: 'Устройства'
                },
                {
                    step: 2,
                    title: 'Протокол',
                    description: 'Выберете протокол Vless',
                    imageUrl: require('./images/ios/vless_incy/step2.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 3,
                    title: 'Подключение',
                    description: 'Нажмите на кнопку быстрое подключение incy',
                    imageUrl: require('./images/ios/vless_incy/step3.jpg'),
                    imageAlt: 'Установка Happ на iOS'
                },
                {
                    step: 4,
                    title: 'Переход в incy',
                    description: 'Нажмите открыть в появившимся окне, если вы его закрыли можете нажать на кнопку открыть в incy',
                    imageUrl: require('./images/ios/vless_incy/step4.jpg'),
                    imageAlt: 'Добавление подписки в Happ'
                },
                {
                    step: 5,
                    title: 'Добавление подписки',
                    description: 'Успешно, ваша подписка подключена!',
                    imageUrl: require('./images/ios/vless_incy/step5.jpg'),
                    imageAlt: 'Подключение VPN в Happ'
                },
            ]
        },
    }
};